<template>
  <v-menu :close-on-content-click="false" max-width="320" offset-x>
    <template v-slot:activator="{ on }">
      <FilterBottom v-on="on" />
    </template>

    <v-card class="pa-3">
      <v-container>
        <BaseFilter
          prepend-inner-icon="mdi-file-table-box-multiple-outline"
          clearable
          single-line
          label="Segmento"
          item-text="descricao"
          item-value="id_band"
          :filters="{ id_band: '2,4' }"
          service="sistemaService.tipoBandeiras"
          v-model="filters.id_band"
          :isCompany="true"
          @change="handleFilter()"
        />

        <BaseFilter
          prepend-inner-icon="mdi-file-table-box-multiple-outline"
          clearable
          single-line
          label="Tipo Meta"
          item-text="tipo_meta"
          item-value="id_tipo_meta"
          service="campanhaService.tipoMeta"
          v-model="filters.id_tipo_meta"
          @change="handleFilter()"
        />
      </v-container>
    </v-card>
  </v-menu>
</template>

<script>
import BaseFilter from "@/components/shared/BaseSelectService";
import FilterBottom from "@/components/shared/bottons/FilterBottom";

export default {
  name: "Filtro",

  components: {
    BaseFilter,
    FilterBottom
  },

  data() {
    return {
      filters: {
        ativo: "S"
      }
    };
  },

  methods: {
    handleFilter() {
      this.$emit("selectedFilters", this.filters);
    }
  }
};
</script>
